import { RootState } from "store";
import Reducers from "types/Reducers";

export const selectConsentDocuments = (state:RootState) => state[Reducers.Consent].documents;
export const selectConsentLinksDocuments = (state:RootState) => state[Reducers.Consent].linksDocuments;
